import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const LogisticsCTA = () => {
  return (
    <section
      data-testid="logistics-cta"
      className="border-t border-[#c9c3b3] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]">(04) — Granada</p>
        </div>

        <Link
          to="/logistica"
          data-testid="logistics-cta-link"
          className="group mt-16 block"
          onClick={() => window.scrollTo(0, 0)}
        >
          <div className="grid grid-cols-12 items-end gap-6 md:gap-10">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="col-span-12 md:col-span-9"
            >
              <h2 className="display-xl inline-flex items-start gap-4">
                Llegar, dormir
                <br />y disfrutar Granada.
                <ArrowUpRight
                  strokeWidth={1}
                  className="mt-2 h-10 w-10 shrink-0 transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 md:h-16 md:w-16"
                />
              </h2>
            </motion.div>
            <div className="col-span-12 md:col-span-3 md:pb-4">
              <p className="body-lead max-w-md">
                Aeropuertos, tren, taxis, los hoteles que recomendamos y qué
                hacer en la ciudad — toda la info práctica en una página aparte.
              </p>
              <span className="mt-4 inline-block corner-label nav-underline">
                Ver la guía de Granada →
              </span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default LogisticsCTA;
